module.exports = __webpack_public_path__ + "img/logo_shine_group_couleur_blanc.c63973fb.png";